module.exports = __webpack_public_path__ + "static/media/gq.dcc3ed9a.svg";